export const DICTIONARIES_SORT_OPTIONS = [
  {
    label: 'Newest first',
    value: '-created_at',
  },
  {
    label: 'Oldest first',
    value: 'created_at',
  },
  {
    label: 'A-Z',
    value: 'name',
  },
  {
    label: 'Z-A',
    value: '-name',
  },
];

export const DICTIONARIES_FILTER_OPTIONS = [
  {
    label: 'Show archived',
    type: 'switch',
    name: 'archived',
    value: '',
    options: [
      {
        label: 'On',
        value: '',
      },
      {
        label: 'Off',
        value: false,
      },
    ],
  },
];
